import {Component} from '@angular/core';
import {TituloLogoPjusService} from "./service/titulo-logo-pjus.service";
import {DeviceDetectorService} from "../../../core/services/device-detector.service";

@Component({
  selector: 'app-titulo-logo-pjus',
  templateUrl: './titulo-logo-pjus.component.html',
  styleUrls: ['./titulo-logo-pjus.component.scss']
})
export class TituloLogoPjusComponent {
  constructor(
    public tituloLogoPjusService: TituloLogoPjusService,
    public deviceDetectorService: DeviceDetectorService,
  ) {}
}
